// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from "vue";
import Vuex from "vuex";
import App from "./App";
import router from "./router";
import Helpers from "./lib/Helpers";
import VueGtag from "vue-gtag";
import { datadogLogs } from "@datadog/browser-logs";

let env = "development";
let logHandler = "console";
const host = document.location.host;
if (host.match(/cogniclick-staging\.app/)) {
  env = "staging";
  logHandler = "http";
} else if (host.match(/cogniclick\.app/)) {
  env = "production";
  logHandler = "http";
}

if (window.convinceConfig.log !== false) {
  datadogLogs.init({
    clientToken: "pub37510a4624e5ee231f014d69e42afe1b",
    site: host,
    forwardErrorsToLogs: true,
    service: "vue-template",
    env: env,
    version: `${window.convinceConfig.tid}-${window.convinceConfig.tc}`,
    sampleRate: 100
  });
}

datadogLogs.logger.setHandler(logHandler);

// IE 11 Polyfill for forEach
// TODO replace when @babel/polyfill handles it, or switch to for...of or [...document.querySelectorAll]
// see https://stackoverflow.com/a/53332776
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

window.addEventListener("message", (event) => {
  if (event.data === "reload") {
    location.href = location.origin + location.pathname;
  }
});

Vue.config.ignoredElements = [/^ion-/, /^trix/];

const mainGtag = window.cogniclick.gtags.splice(0, 1)[0];
const includes = [];
const config = {
  id: mainGtag,
  anonymize_ip: true,
  custom_map: { dimension1: "cogniclick_campaign" }
};
if (window.cogniclick.gtags.length > 0) {
  // eslint-disable-next-line no-unused-vars
  for (const tag of window.cogniclick.gtags) {
    includes.push({ id: tag, anonymize_ip: true });
  }
}

Vue.use(
  VueGtag,
  {
    config,
    includes
  },
  router
);

Vue.config.productionTip = false;
Vue.use(Vuex);

const store = require("./store/Store.js").default;

Vue.mixin(Helpers);

new Vue({
  render: (h) => h(App),
  store,
  router,
  components: { App }
}).$mount("#app");
